import CONFIG from 'Config';
import BaseHSFormModel from './BaseHSFormModel';

const formParams = {
  email: {
    type: 'email',
    validate: {
      email: true,
      required: true,
    },
  },
  first_name: {
    type: 'string',
    validate: {
      required: true,
    },
  },
  last_name: {
    type: 'string',
    validate: {
      required: true,
    },
  },
  coming_soon: {
    type: 'bool',
  },
  invested_in_farmland_before: {
    type: 'bool',
  },
};

export default class RegisterHSModel extends BaseHSFormModel {
  constructor() {
    super();

    this.$scrollTopOnSuccess = false;
    this.$messageSuccess = false;
    this.$hsFormId = CONFIG.hubspotFormIds.registerUser;
    this._setParams(formParams);
    this.invested_in_farmland_before = null;
  }

  get $changedData() {
    return this.$data;
  }
}
